import { render, staticRenderFns } from "./update-manager.vue?vue&type=template&id=2cf9f036&scoped=true&"
import script from "./update-manager.vue?vue&type=script&lang=js&"
export * from "./update-manager.vue?vue&type=script&lang=js&"
import style0 from "./update-manager.vue?vue&type=style&index=0&id=2cf9f036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf9f036",
  null
  
)

export default component.exports